import { MigrationControllerApi, UploadFileCategoryEnum } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */

interface Params {
  category: UploadFileCategoryEnum;
  title: string;
  file: File;
  providerGroupUuid?: string;
}
export const usePgAddPatients = () =>
  useMutationWithLoading(async (params: Params) =>
    new MigrationControllerApi(getConfigObject()).uploadFile(
      "PATIENT",
      params.title,
      params.file,
      params.providerGroupUuid
    )
  );
